import { useMemo } from "react";
import { useLocation } from "react-router";

import { useI18n } from "../../../i18n/I18nProvider.js";
import {
    usePublishDinoContext
} from "./DinoContextProvider.js";
import {
    deriveDinoRouteContext
} from "./dinoRouteContext.js";

const ROUTE_CONTEXT_SOURCE = "route";

function DinoRouteContextBridge() {
    const { language } = useI18n();
    const { pathname, search } = useLocation();

    const context = useMemo(
        () => deriveDinoRouteContext({
            language,
            pathname,
            search
        }),
        [language, pathname, search]
    );

    usePublishDinoContext(
        ROUTE_CONTEXT_SOURCE,
        context
    );

    return null;
}

export {
    DinoRouteContextBridge,
    ROUTE_CONTEXT_SOURCE,
    deriveDinoRouteContext
};
